export enum CompanyGroupFilterNames {
  NAME = "name",
  COMPANIES = "companies",
}

export enum CompanyGroupBenefitAssignmentFilterNames {
  NAME = "name",
  TYPE = "type",
}
